import { useEffect, useState } from "react";

/**
 * useMediaQuery
 *
 * Subscribe to a CSS media query and re-render on change. Used to collapse the
 * sidebar automatically on narrow windows.
 *
 * @example
 *   const isNarrow = useMediaQuery("(max-width: 720px)");
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
